import React, { useState } from 'react'
import { BtnProps } from './types'
import { FormValues } from 'donate/types'
import { connect } from 'formik'
import { copyToClipboard } from 'shared'

export const FakeButtons = connect<{}, FormValues>(({ formik }) => {
  if (!formik.values._show_fake_buttons) return null

  return (
    <div className="generic-admin-box for-platform-admins mb-3">
      <h2 className="mt-0 mb-1">Fill with fake data</h2>
      <div className="space-y-1">
        <FakePaymentDataButton method="stripe_sepa_debit" title="IBAN (success)" value="DE89370400440532013000" />
        <FakePaymentDataButton
          method="stripe_sepa_debit"
          title="IBAN (success after 3 minutes)"
          value="DE08370400440532013003"
        />
        <FakePaymentDataButton
          method="stripe_sepa_debit"
          title="IBAN (success + dispute)"
          value="DE35370400440532013002"
        />
        <FakePaymentDataButton method="stripe_sepa_debit" title="IBAN (invalid)" value="GB94BARC20201530093459" />
        <FakePaymentDataButton method="stripe_cc" title="Credit Card (VISA US)" value="4242424242424242" />
        <FakePaymentDataButton
          method="stripe_cc"
          title="Credit Card (initial SCA, off-session always)"
          value="4000002500003155"
        />
        <FakePaymentDataButton method="stripe_cc" title="Credit Card (always SCA)" value="4000002760003184" />
        <FakePaymentDataButton
          method="stripe_cc"
          title="Credit Card (initial SCA, then insufficient funds)"
          value="4000008260003178"
        />
        <FakePaymentDataButton method="stripe_cc" title="Credit Card (Mastercard US)" value="5555555555554444" />
        <FakePaymentDataButton method="stripe_cc" title="Credit Card (VISA DE)" value="4000002760000016" />
        <FakePaymentDataButton method="direct_deposit" title="Direct Deposit" />
        <FakePaymentDataButton method="paypal" title="PayPal" />
        <FakePaymentDataButton method="stripe_giropay" title="Giropay" />
        <FakePaymentDataButton method="dummy_payment" title="Dummy Payment (only for testing!)" />
        <FakeCaptchaButton
          title="Fake empty CAPTCHA"
          onClick={() => {
            void formik.setFieldValue('captcha_solution', '')
          }}
        ></FakeCaptchaButton>
        <FakeCaptchaButton
          title="Fake invalid CAPTCHA"
          onClick={() => {
            void formik.setFieldValue('captcha_solution', 'invalid')
          }}
        ></FakeCaptchaButton>
      </div>
    </div>
  )
})

const FakePaymentDataButton = connect<BtnProps, FormValues>(({ formik, method, title, value }) => {
  if (!formik.values._payment_methods.includes(method)) return null

  const [copied, setCopied] = useState(false)

  const fillWithFakeData: React.MouseEventHandler = (event) => {
    event.preventDefault()
    void formik.setFieldValue('first_name', 'Test')
    void formik.setFieldValue('last_name', 'Horst')
    void formik.setFieldValue('receipt_desired', true)
    void formik.setFieldValue('street', 'Hauptstr. 23')
    void formik.setFieldValue('zip', '12345')
    void formik.setFieldValue('city', 'Entenhausen')
    void formik.setFieldValue('email', `test_horst_${Math.floor(Math.random() * 10) + 1}@betterplace.org`)
    void formik.setFieldValue('payment_method', method)
    formik.setErrors({})
    setTimeout(() => void formik.validateForm(), 300) // TODO: Why!!! Fix this validation
    value && setCopied(copyToClipboard(value))
    // Its hard to find a good place to jump to. This is about where the iban/card-number and donate button is.
    setTimeout(() => {
      document.getElementsByTagName('h4')[3]?.scrollIntoView?.({ behavior: 'smooth' })
    }, 200)
    setTimeout(() => {
      setCopied(false)
    }, 5000) // reset and hide info
  }

  return (
    <div>
      <button onClick={fillWithFakeData} className="btn btn-secondary">
        {title}
      </button>
      {value && (
        <span>
          {' '}
          <code>{value}</code>
        </span>
      )}
      {copied && (
        <span className="fixed top-0 right-0 p-2 rounded bg-red-700 text-white transition-transform">
          Copied {value}
        </span>
      )}
    </div>
  )
})

const FakeCaptchaButton = ({ onClick, title }: { onClick: () => void; title: string }) => {
  return (
    <div>
      <button type="button" onClick={onClick} className="btn btn-secondary">
        {title}
      </button>
    </div>
  )
}
